export default "__VITE_ASSET__DztwFWEj__"